import axios from 'axios';

const getExpenseRevenueByPrograms = (cancelToken) => {
  return axios.get('/api/budget/expense-revenue-by-programs', { cancelToken });
};

const getItemNamesByTypes = (cancelToken) => {
  return axios.get('/api/account/item-names-by-type', { cancelToken });
};

const getResultSpending = (cancelToken) => {
  return axios.get('/api/budget/result-spending', { cancelToken });
};

const getQuartileSpending = () => {
  return axios.get('/api/budget/quartile-spending');
};

export {
  getExpenseRevenueByPrograms,
  getItemNamesByTypes,
  getResultSpending,
  getQuartileSpending
};
